<template>
    <div class="product">
        <div class="product-hall-banner"></div>
        <div class="index-main">
            <div class="main-support">
                <div class="container">
                    <h4 class="support-title">PROFESSIONAL AND COMPREHENSIVE TECHNICAL SUPPORT</h4>
                    <h5 class="support-slogan">我们能为你提供的价值</h5>
                    <div class="suppport-arrow-down">
                        <img class="support-arrow-img slide-down" src="../../assets/img/arrow-down-black.png" alt="我们能为你提供的价值">
                    </div>
                    <div class="main-support-info">
                        新能源场站工作人员较少，管辖设备较多，巡检压力较大，<br>
                        需要借助技术手段保证新能源场站电气设备的安全。<br>
                        新型传感技术成为未来发电企业何电网企业高效运维和设备状态监测所必须的，<br>
                        针对开关设备、电缆等一次设备，<br>
                        加装测温、局放等状态监测传感器，<br>
                        成为未来保证电气设备可靠性和检修决策的重要手段。
                    </div>
                </div>
            </div>
        </div>

        <div class="container product-hall-img1 product-hall-img"></div>
        <div class="container product-hall-img2 product-hall-img">
            <div class="content">
                <h2>技术指标</h2>
                <strong>无源温度传感器</strong>采用新型声表面波技术，无线传送温度信息。采用433MHz免申请频段不易受现场电磁干扰，具有体积小、结构简单、可塑性强、免维护等特点。<br>
                <h2></h2>
                <strong>无线测温采集终端</strong><sub>（含发射接收天线）</sub>用来收集传感头的温度信号，将其重新打包，通过有线或无线方式发送至后台监控系统，安装在测温现场。
            </div>
        </div>
        <div class="container product-hall-img3 product-hall-img" style="margin-bottom: 50px;"></div>

    </div>
    
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
}

.product-hall-banner {
    width: 100%;
    height: 530px;
    background: url(../../assets/img/product/pro-banner5.jpg) center;
}

main {
    display: block;
}

section {
    display: block;
}

h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}

h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

h5 {
    display: block;
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.index-main .main-support {
    width: 100%;
    // height: 551px;
    color: #333;
    text-align: center;
    background: #fff;
    border-top: 1px solid #ffffff;
    padding-bottom: 40px;

    .support-title {
        font-size: 28px;
        font-weight: 200;
        font-family: "Ping Fang";
        margin: 70px 0 35px 0;
        text-transform: uppercase;
    }

    .support-slogan {
        font-size: 22px;
        font-weight: 700;
    }

    .support-arrow-down {
        opacity: .4;
        margin-top: 20px;
    }
    
    .main-support-info {
        margin-top: 65px;
        font-size: 16px;
        text-align: center;
        line-height: 28px;
    }
}

.product-hall-img {
    position: relative;

    .content {
        position: absolute;
        text-align: left;
        color: #666;
        font-size: 14px;
        line-height: 22px;
        max-width: 380px;
        margin-bottom: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        h2 {color: #333;}
    }
}

.product-hall-img1 {
    width: 100%;
    height: 500px;
    background: url(../../assets/img/product/pro5-img1.jpg) center;
    text-align: center;
    color: #fff;
}

.product-hall-img2 {
    width: 100%;
    height: 500px;
    background: url(../../assets/img/product/pro5-img2.jpg) center;
    text-align: center;

    .content {
        right: 50px;
        top: 150px;
    }
}

.product-hall-img3 {
    width: 100%;
    height: 520px;
    background: url(../../assets/img/product/pro5-img31.jpg) center;
    text-align: center;
    color: #fff;
}
 
.section {width: 100%;}
.container {
    max-width: 1000px;
    min-width: 1000px;
    margin: auto;
    width: 100%;
}


</style>